import { alertMode } from "../../../main/data/alert-mode.ts";
import { alert } from "../../../main/functions/alert.js";
import { notify } from "../../../main/functions/notify.js";
import { setAlertAsDismissed } from "../../../main/functions/set-alert-as-dismissed.js";
import { silenceAlert } from "../../../main/functions/silence-alert.js";
import { useMainStore } from "../../../main/store/mainStore.js";
import { loggingContexts } from "../logs/data/logging-contexts.js";
import { log } from "../logs/log.js";
import { addIncomingMessage } from "./add-incoming-message.js";
import { classifyIncomingMessage } from "./classify-incoming-message.js";
import { incomingMessagesTypes } from "./data/incoming-messages-types.js";

const incomingMessageLog = log(loggingContexts.incomingMessage);

export const handleIncomingMessages = async ({ message }) => {
  const caseID =
    message?.message?.payload?.caseId ||
    message?.message?.payload?.case?.id ||
    message?.message?.caseID ||
    null;

  const type = classifyIncomingMessage({ message });

  incomingMessageLog.info("incoming message locally classified as", type);

  const incomingMessageID = await addIncomingMessage({
    caseID,
    message,
    type,
  });

  if (type === incomingMessagesTypes.Alert) {
    const mainStore = useMainStore();

    const messagePayload = message.message?.payload;

    if (
      mainStore.alertMode === alertMode.notifyOnly ||
      (mainStore.alertMode ===
        alertMode.alertForCaseCreationAndThenNotifyOnly &&
        messagePayload?.data?.eventName !== "Incoming Patient")
    ) {
      notify({ caseID, messagePayload });

      return;
    }

    alert({ alertID: incomingMessageID, caseID });
  }

  if (type === incomingMessagesTypes.ConnectivityCheckToMessagingServers) {
    const mainStore = useMainStore();

    const messagePayload = message.message;

    mainStore.messagingServersConnectivityCheckResponse = messagePayload;
  }

  if (type === incomingMessagesTypes.Silence) {
    silenceAlert({ message });

    setAlertAsDismissed({ message });
  }
};
